import { c as _c } from "react/compiler-runtime";
import { DateCell } from "@components/common/date-cell";
import { useMemo } from "react";
import { FaroTableColumnVisibilityMenuIcon } from "@components/common/faro-table/faro-table-column-visibility-menu-icon";
import { useColumnPreferencesContext } from "@context-providers/table/column-preferences-provider";
import { TableHeaderWithDraggableIcon } from "@components/table/table-header-with-draggable-icon";
import { SNAPSHOTS_TABLE_COLUMN_LABELS } from "@pages/project-details/project-snapshots/snapshots-table-constants";
import { isSnapshotsTableColumnField } from "@custom-types/type-guards";
import { SnapshotName } from "@pages/project-details/project-snapshots/snapshot-name";
import { SnapshotOptions } from "@pages/project-details/project-snapshots/snapshot-options";
import { Box } from "@mui-wrapper";
import { FaroCoreApiUtils } from "@stellar/core-api-client";

/**
 * @returns the columns definition to be used in the snapshots table
 */
export function useSnapshotsTableColumns() {
  const $ = _c(10);
  const {
    columnPreferences,
    visibleOrderedColumns
  } = useColumnPreferencesContext();
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      field: "name",
      headerName: SNAPSHOTS_TABLE_COLUMN_LABELS.name,
      flex: 1,
      minWidth: 220,
      sortable: true,
      disableReorder: true,
      renderCell: _temp
    };
    t1 = {
      field: "created",
      headerName: SNAPSHOTS_TABLE_COLUMN_LABELS.created,
      minWidth: 22,
      sortable: true,
      renderHeader: _temp2,
      renderCell: _temp3
    };
    t2 = {
      field: "accessLevel",
      headerName: SNAPSHOTS_TABLE_COLUMN_LABELS.accessLevel,
      minWidth: 180,
      renderHeader: _temp4,
      renderCell: _temp5,
      sortable: true
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== columnPreferences) {
    t3 = {
      name: t0,
      created: t1,
      accessLevel: t2,
      options: {
        field: "options",
        type: "actions",
        align: "right",
        width: 90,
        disableReorder: true,
        renderHeader: () => <FaroTableColumnVisibilityMenuIcon columnPreferences={columnPreferences} />,
        renderCell: _temp6,
        sortable: false
      }
    };
    $[3] = columnPreferences;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const columnsMap = t3;
  let t4;
  if ($[5] !== columnsMap || $[6] !== visibleOrderedColumns) {
    let t5;
    if ($[8] !== columnsMap) {
      t5 = header => columnsMap[header];
      $[8] = columnsMap;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = visibleOrderedColumns.filter(isSnapshotsTableColumnField).map(t5);
    $[5] = columnsMap;
    $[6] = visibleOrderedColumns;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const orderedColumns = t4;
  return orderedColumns;
}
function _temp6(params_4) {
  return <SnapshotOptions snapshot={params_4.row.entity} />;
}
function _temp5(params_3) {
  const accessLevel = params_3.row.entity.accessLevel;
  return <Box sx={{
    px: 1
  }}>{FaroCoreApiUtils.Project.AccessLevelDisplayNames[accessLevel]}</Box>;
}
function _temp4(params_2) {
  return <TableHeaderWithDraggableIcon title={params_2.colDef.headerName ?? ""} />;
}
function _temp3(params_1) {
  return <Box sx={{
    px: 1
  }}><DateCell date={params_1.row.entity.createdAt} /></Box>;
}
function _temp2(params_0) {
  return <TableHeaderWithDraggableIcon title={params_0.colDef.headerName ?? ""} />;
}
function _temp(params) {
  return <SnapshotName snapshot={params.row.entity} />;
}